export default "__VITE_ASSET__rsZRHUom__"